import crudFactory from "../crudFactory.ts";
import { useAxios } from "@/compositions";
import type { OrderWidgetsResponse, OrdersWorkspaceResponse } from "./types.ts";

const MODEL = "orders";

const COMMON_CRUD_APIs = crudFactory(MODEL);

const { axiosInstance } = useAxios(`${import.meta.env.VITE_API_BASE_URL}/v1/`);

export default {
  ...COMMON_CRUD_APIs,
  getWidgets: async (): Promise<OrderWidgetsResponse> => (await axiosInstance.get(`${MODEL}/widgets`)).data,
  getWorkspace: async (): Promise<OrdersWorkspaceResponse> => (await axiosInstance.get(`${MODEL}/workspace`)).data
};
